import "./Home.module.css";
import Hovedmeny from "@/reusable_sections/Header";
import SeenWhereLinkopingMoves from "./sections/SeenWhereLinkopingMoves";
import HowItWorks from "./sections/HowItWorks";
import PopularAdventures from "./sections/PopularAdventures";
import TryggDigitalLeverans from "./sections/TryggDigitalLeverans";
import SagtOmVaraByggprojekt from "./sections/SagtOmVaraByggprojekt";
import UtforskaKategorier from "./sections/UtforskaKategorier";
import SidfotInfo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Hovedmeny />
      <SeenWhereLinkopingMoves />
      <HowItWorks />
      <PopularAdventures />
      <TryggDigitalLeverans />
      <SagtOmVaraByggprojekt />
      <UtforskaKategorier />
      <SidfotInfo />
    </div>;
}